import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthStateService } from '../services/auth-state.service';

/**
 * Auth guard that checks if user is authenticated
 * Redirects to login if not authenticated
 * Uses app-specific token storage keys
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authStateService = inject(AuthStateService);
  const router = inject(Router);

  // Check if app type is initialized
  const appType = authStateService.getAppType();
  if (!appType) {
    console.warn('AuthStateService not initialized. Please call initialize() in app initialization.');
    // Try to detect app type from URL or default to ticketing
    let detectedAppType: any = 'ticketing';
    if (window.location.hostname.includes('hac') || state.url.includes('/hac') || state.url.includes('/private-events')) {
      detectedAppType = 'hac';
    } else if (window.location.hostname.includes('portal') || window.location.hostname.includes('client')) {
      detectedAppType = 'client-portal';
    }
    authStateService.initialize(detectedAppType);
  }

  if (authStateService.isAuthenticated()) {
    return true;
  }

  // Store the attempted URL for redirect after login
  const loginRoute = authStateService.getLoginRoute();
  router.navigate([loginRoute], {
    queryParams: { returnUrl: state.url },
  });
  return false;
};

